const table201 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "interest_earning_amount",
        name: "公社債及び預貯金の利子、合同運用信託、公社債投資信託及び公社債等運用投資信託(特定公社債等運用投資信託を除く。)の収益の分配並びに特定公社債等運用投資信託の受益権及び特定目的信託の社債的受益権に係る剰余金の配当_収入金額",
        editable: true
    },
    {
        key: "interest_amount_income_tax",
        name: "公社債及び預貯金の利子、合同運用信託、公社債投資信託及び公社債等運用投資信託(特定公社債等運用投資信託を除く。)の収益の分配並びに特定公社債等運用投資信託の受益権及び特定目的信託の社債的受益権に係る剰余金の配当_所得税額･復興特別所得税額",
        editable: true
    },
    {
        key: "interest_amount_deduction_income_tax",
        name: "公社債及び預貯金の利子、合同運用信託、公社債投資信託及び公社債等運用投資信託(特定公社債等運用投資信託を除く。)の収益の分配並びに特定公社債等運用投資信託の受益権及び特定目的信託の社債的受益権に係る剰余金の配当_控除所得税額･控除復興特別所得税額",
        editable: true
    }
];

export { table201 };
